import GridContainer from "components/common/GridContainer";
import GridItem from "components/common/GridItem";
import { Button } from "@mui/material";
import React from "react";

function FreeForm(props) {
    const { editableForm: EditableForm } = props;

    return (
        <GridContainer direction="column" card>
            <GridItem>
                <EditableForm {...props} />
            </GridItem>

            <GridItem>
                {/* <Button onClick={props.onCancel}>Cancel</Button>*/}

                <Button
                    variant="contained"
                    onClick={props.handleSave}
                    disabled={!props.canSave}
                >
                    Save
                </Button>
            </GridItem>
        </GridContainer>
    );
}

export default FreeForm;
